// @ts-nocheck

export type TicketGetWithRoomPlans = typeof TicketGetWithRoomPlans[keyof typeof TicketGetWithRoomPlans];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketGetWithRoomPlans = {
  true: 'true',
  false: 'false',
} as const;
